var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstashowBarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272.864,
    height: 44.95,
    viewBox: "0 0 272.864 44.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2164",
    "data-name": "Rectangle 2164",
    width: 272.864,
    height: 44.95,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2163",
    "data-name": "Rectangle 2163",
    width: 2.514,
    height: 36.363,
    transform: "translate(49.955 8.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M129,38.528h2.577v3.205c1.068-2.116,3.645-3.526,7.479-3.526,6.976,0,9.993,4.551,9.993,10.706V65h-2.577V49.17c0-5.193-2.451-8.4-7.416-8.4s-7.479,3.333-7.479,8.142V65H129Z",
    transform: "translate(-69.441 -20.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M191.435,40.633c-2.451,0-4.525,1.475-4.525,4.039,0,2.756,2.074,3.654,4.965,4.679,3.834,1.41,8.3,2.949,8.3,8.334,0,4.231-3.331,7.757-8.484,7.757a9.671,9.671,0,0,1-9.05-5.577l2.2-1.346a7.4,7.4,0,0,0,6.851,4.3c3.9,0,5.907-1.987,5.907-5.129,0-3.718-3.268-4.744-6.787-5.962-3.205-1.09-6.473-2.564-6.473-7.052a6.8,6.8,0,0,1,7.1-6.6,9.424,9.424,0,0,1,7.353,3.077L196.9,42.813a7.068,7.068,0,0,0-5.468-2.18",
    transform: "translate(-98.313 -20.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M228.589,30.085V27.456h4.724V17.639h2.577v9.817h4.456v2.628h-4.456V53.932h-2.577V30.085Z",
    transform: "translate(-123.049 -9.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M259.313,51.724A13.494,13.494,0,0,1,272.7,38.069a13.155,13.155,0,0,1,10.37,5V38.454h2.577V64.93H283.07V60.378a13.155,13.155,0,0,1-10.37,5,13.494,13.494,0,0,1-13.387-13.655M272.7,62.814a11.093,11.093,0,1,0-10.873-11.09A10.947,10.947,0,0,0,272.7,62.814",
    transform: "translate(-139.588 -20.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M387.161,17.487h2.577V30.9c1.32-2.18,3.582-3.911,7.73-3.911,6.977,0,10.245,4.231,10.245,10.706V53.915h-2.577V37.952c0-5.193-2.451-8.4-7.668-8.4-5.154,0-7.73,3.59-7.73,7.052V53.85h-2.577Z",
    transform: "translate(-208.409 -9.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M454.947,65.3a13.69,13.69,0,1,1,13.387-13.655A13.494,13.494,0,0,1,454.947,65.3m0-2.564a11.125,11.125,0,1,0-10.873-11.09,10.946,10.946,0,0,0,10.873,11.09",
    transform: "translate(-237.692 -20.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M339,32.621l-.018-.007c-3.878-1.6-7.542-3.111-7.542-6.984,0-3.021,2.246-6.07,7.264-6.07,4.379,0,6.419,2.174,7.245,3.471l.1.151,2.477-1.016-.124-.213c-1.049-1.8-3.7-4.833-9.695-4.833a10.857,10.857,0,0,0-7.077,2.37,7.942,7.942,0,0,0-2.807,6.14c0,5.775,4.991,7.813,9,9.45,4.452,1.809,9.055,3.68,9.055,9.053,0,2.774-1.124,7.427-8.654,7.427-4.639,0-7.543-2.056-8.877-6.285l-.065-.206-2.6.835.062.2c1.653,5.346,5.408,7.944,11.477,7.944,7.165,0,11.273-3.615,11.273-9.918,0-6.492-4.964-9.149-10.5-11.511",
    transform: "translate(-175.856 -9.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M537.515,39.058l-8.673,22.209L521.9,39.232H519.19l-7,22.1-8.736-22.278h-2.765l10.256,26.468h2.639l6.965-22.12,6.859,22.12h2.634l10.367-26.468Z",
    transform: "translate(-269.52 -21.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M0,18.242V44.01H14.347V41.63H2.374V19.271L19.326,3.263,36.342,19.207V41.63H24.368v2.38H38.715V18.176L19.32,0Z",
    transform: "translate(0 0)",
    fill: "#d63f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M575.209,87.828H577.9v.3H576.73v3.409h-.35V88.126h-1.171Z",
    transform: "translate(-309.635 -47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M583.469,91.535V87.828H584l1.212,3.269h.01l1.192-3.269h.529v3.707H586.6V88.23h-.01l-1.212,3.306h-.329l-1.217-3.306h-.01v3.306Z",
    transform: "translate(-314.082 -47.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M30.035,66.231A12.5,12.5,0,0,1,19.247,60a14.758,14.758,0,0,0,2.106-1.218,10.026,10.026,0,0,0,17.364,0A16.659,16.659,0,0,1,40.823,60a12.5,12.5,0,0,1-10.788,6.227",
    transform: "translate(-10.361 -31.638)",
    fill: "#d63f94"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstashowBarLogo);
export default __webpack_public_path__ + "static/media/instashow-bar-logo.4d41dc6eadc2b2479e53a99d1afba13f.svg";
export { ForwardRef as ReactComponent };